import InsurancePolicy from './InsurancePolicy';

export default InsurancePolicy;
